import { Card, CardContent } from "@/components/ui/card";
import { useContext } from "react";
import { CalendlyContext } from "@/App";

const features = [
  {
    title: "Seamless Integration",
    description: "Our solutions integrate effortlessly with your existing tech stack, minimizing disruption and maximizing ROI.",
    stat: "100%",
    statText: "Compatible",
    icon: (
      <svg className="w-12 h-12 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
    ),
  },
  {
    title: "Regulatory Compliance",
    description: "Stay compliant with GDPR, HIPAA, and industry-specific regulations with our certified solutions.",
    stat: "100%",
    statText: "Compliant",
    icon: (
      <svg className="w-12 h-12 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
      </svg>
    ),
  },
  {
    title: "Measurable ROI",
    description: "Our commitment to your success includes delivering tangible ROI within the first 90 days of deployment.",
    stat: "90-Day",
    statText: "ROI",
    icon: (
      <svg className="w-12 h-12 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    ),
  },
];

const WhyChooseSection = () => {
  const { setIsOpen } = useContext(CalendlyContext);

  return (
    <section id="why-us" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">
            Why Choose <span className="gradient-text">Advensify</span>
          </h2>
          <p className="section-subtitle">
            Our commitment to excellence sets us apart in the AI and software development industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden hover:transform hover:-translate-y-2"
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-6 p-4 rounded-full bg-emerald-50">
                    {feature.icon}
                  </div>
                  <div className="flex flex-col items-center mb-4">
                    <span className="text-4xl font-bold text-emerald-500 font-montserrat">{feature.stat}</span>
                    <span className="text-lg text-gray-500">{feature.statText}</span>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 font-montserrat">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="mt-16 p-8 bg-gradient-to-r from-emerald-700 to-emerald-900 rounded-xl text-white text-center">
          <h3 className="text-2xl font-semibold mb-4 font-montserrat">Ready to transform your business?</h3>
          <p className="mb-6 text-lg opacity-90 max-w-2xl mx-auto">
            Join leading enterprises who trust Advensify to deliver cutting-edge AI and software solutions.
          </p>
          <button 
            onClick={() => setIsOpen(true)}
            className="bg-white text-emerald-700 hover:bg-gold-500 hover:text-gray-800 transition-all duration-300 font-semibold py-3 px-8 rounded-md shadow-lg"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
